import { useMemo } from 'react';

import { observer } from 'mobx-react-lite';

import { FormLabel } from '@components/form-label';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { TextEditor } from '@components/text-editor';
import { TextField } from '@components/text-field';
import { debounce } from '@utils/browser';
import { editorStateToHtml } from '@utils/draftjs';

import { TextEditorToolbar } from 'components/TextEditorToolbar';
import { useBoolean } from 'hooks/useBoolean';
import { configs } from 'jobboards/configs';
import { useStore } from 'models/Provider';

export const PromoteHIForm = observer(({ boardState }) => {
  const { t, lang } = useStore();
  const update = useMemo(
    () =>
      debounce((es) => {
        boardState.setRequirements(editorStateToHtml(es));
      }, 200),
    [boardState],
  );

  return (
    <>
      <Stack space={6}>
        <RequiredInput label="* Titill" value={boardState.title} onChange={boardState.setTitle} />

        <RequiredInput
          label="* Netfang tengiliðs"
          value={boardState.contactEmail}
          onChange={boardState.setContactEmail}
        />

        <RequiredInput
          label="* Nafn tengiliðs"
          value={boardState.contactName}
          onChange={boardState.setContactName}
        />

        <RequiredInput
          label="* Starfshlutfall"
          value={boardState.ratio}
          onChange={boardState.setRatio}
        />

        <Stack space={1}>
          <FormLabel text="Hæfniskröfur" />
          <TextEditor variant="gray" initialEditorState={boardState.requirements} onChange={update}>
            <TextEditorToolbar />
            <TextEditor.Input />
          </TextEditor>
        </Stack>

        <Stack space={6}>
          <Separator />
          <FormLabel text={t('jobboards.hi.info')} />
          <Text text={configs.hi[lang].priceText} />
          <Separator />
        </Stack>
      </Stack>
    </>
  );
});

const RequiredInput = observer((props) => {
  const { t } = useStore();
  const { value, ...rest } = props;
  const [touched, { on, off }] = useBoolean(false);

  return (
    <TextField
      {...rest}
      value={value}
      onBlur={on}
      onFocus={off}
      error={touched && !value ? t('errors.required') : ''}
    />
  );
});
